import { useCallback, useEffect, useRef } from 'react'

// Dispara onReachBottom cuando un elemento centinela entra (o casi) en el viewport.
// Agnóstico al contenedor que scrollea: sirve con window (legacy) o con el
// contenedor del shell (.vib-eproject-shell__content, overflow-y:auto).
//
// Devuelve una *callback ref*: React la invoca con el nodo en cuanto el centinela
// se monta (y con null al desmontarse). Así el observer se engancha justo cuando
// aparece el centinela, aunque se renderice condicionalmente tras cargar datos
// (p. ej. ProjectList monta la lista solo cuando hay proyectos).
export default function useInfiniteScroll(onReachBottom, { rootMargin = '200px' } = {}) {
	// Siempre invoca el callback más reciente → evita closures obsoletas sin
	// depender del array de deps de cada vista.
	const callbackRef = useRef(onReachBottom)
	callbackRef.current = onReachBottom

	const observerRef = useRef(null)

	const setSentinel = useCallback((node) => {
		if (observerRef.current) {
			observerRef.current.disconnect()
			observerRef.current = null
		}
		if (!node || typeof IntersectionObserver === 'undefined') return

		observerRef.current = new IntersectionObserver(
			([entry]) => { if (entry.isIntersecting) callbackRef.current() },
			{ rootMargin }
		)
		observerRef.current.observe(node)
	}, [rootMargin])

	useEffect(() => () => {
		if (observerRef.current) observerRef.current.disconnect()
	}, [])

	return setSentinel
}
